import { defineTool } from '@/shell/tool';

/** Regions (Flutter `/regions`). */
export default defineTool({
  id: 'regions',
  title: 'Regions',
  summary: 'The regions a network, a course and a year level belong to.',
  section: 'learning-backend',
  order: 10,
  icon: 'public',
  owner: '@Drabu',
  permission: 'regions:use',
  routes: () => import('./RegionsPage'),
});
